import React from "react";
import StripePaymentForm from "./StripePaymentForm";

export default function StripeContainer({ order }) {
  return <StripePaymentForm order={order} />;
}
